import PropTypes from 'prop-types';
import React from 'react';
import omit from 'lodash.omit';

import StyledHeadline from './headline.style';

const Headline = props => {
  const { tag = 'h2', children, className } = props;
  return (
    <StyledHeadline className={className} as={tag} {...omit(props, ['children', 'tag'])}>
      {children}
    </StyledHeadline>
  );
};

Headline.propTypes = {
  className: PropTypes.string,
  children: PropTypes.node,
  tag: PropTypes.oneOf(['h1', 'h2', 'h3', 'h4', 'h5', 'h6', 'p', 'span'])
};

export default Headline;
